import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Sun, Compass, Heart, Zap } from 'lucide-react';
export function WhoIsThisFor() {
  const items = [{
    icon: Moon,
    text: 'Para quien siente ansiedad o confusión interna'
  }, {
    icon: Zap,
    text: 'Para quien necesita claridad rápida'
  }, {
    icon: Heart,
    text: 'Para quien busca guía emocional, no predicciones'
  }, {
    icon: Sun,
    text: 'Para quien quiere una lectura simple pero profunda'
  }, {
    icon: Compass,
    text: 'Para quien desea tomar una decisión con más confianza'
  }];
  return <section className="py-24 px-4 bg-[#111522]" data-id="element-332">
      <div className="max-w-4xl mx-auto" data-id="element-333">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-16" data-id="element-334">
          <h2 className="text-4xl font-serif text-[#F7F5F2] mb-4" data-id="element-335">
            ¿Para quién es esta lectura?
          </h2>
          <div className="w-24 h-px bg-[#CFA86A] mx-auto" data-id="element-336" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-337">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="bg-[#0C0F17]/50 p-6 rounded-xl border border-[#CFA86A]/20 hover:border-[#CFA86A]/40 transition-colors duration-300 flex flex-col items-center text-center" data-id="element-338">
              <item.icon className="w-8 h-8 text-[#CFA86A] mb-4" data-id="element-339" />
              <p className="text-[#F7F5F2] font-medium" data-id="element-340">{item.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}